export const getState = state => {
  return state.maccsInternshipsManager
}
